import { useState } from "react";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";

import { useDeleteTour } from "../../api/tours";
import { useDisclosure } from "../../hooks/useDisclosure";
import StyledModal from "../../Components/Modal/StyledModal";
import {
  getApiErrorMessage,
  getTourEditorPath,
} from "./utils/tourEditorUtils";
import styleTours from "./Tours.module.css";

const openEditor = (title, id) => {
  window.open(
    `${window.location.origin}${getTourEditorPath(title, id)}`,
    "_blank",
    "noopener,noreferrer"
  );
};

export const useColumns = refetch => {
  const [deleteId, setDeleteId] = useState(null);
  const { onOpen, isOpen, onClose } = useDisclosure();
  const { mutateAsync: mutateAsyncDelete, isLoading: isLoadingDelete } =
    useDeleteTour();

  const handleDelete = id => {
    setDeleteId(id);
    onOpen();
  };

  const handleDeleteTour = () => {
    mutateAsyncDelete(deleteId)
      .then(res => {
        toast.success(res?.data?.message || "360 Tour deleted successfully");
        onClose();
        refetch();
      })
      .catch(err => {
        toast.error(getApiErrorMessage(err, "Failed to delete tour"));
        onClose();
      });
  };

  const columns = [
    {
      title: "S.N",
      render: ({ sn }) => {
        return <div>{sn}</div>;
      },
    },
  
    {
      title: "Tour Name",
      render: ({ title }) => {
        return <div>{title}</div>;
      },
    },
    {
      title: "ID",
      render: ({ id }) => {
        return <div>{id}</div>;
      },
    },
    {
      title: "View Tour",
      render: row => {
        return (
          <div>
            <button
              type="button"
              className="bg-[#299aff] px-4 py-2 rounded text-white"
              onClick={() => openEditor(row.title, row.id)}
            >
              View
            </button>
          </div>
        );
      },
    },
    {
      title: "Action",
      render: row => {
        return (
          <div>
            <button
              type="button"
              className={styleTours["modify-tour-btn"]}
              onClick={() => openEditor(row.title, row.id)}
            >
              <FontAwesomeIcon icon={faPen} />
            </button>{" "}
            <button
              type="button"
              className={styleTours["delete-tour-btn"]}
              onClick={() => handleDelete(row.id)}
            >
              <FontAwesomeIcon icon={faTrashCan} />
            </button>
            <StyledModal
              isOpen={isOpen}
              onClose={onClose}
              onConfirm={handleDeleteTour}
              loading={isLoadingDelete}
            />
          </div>
        );
      },
    },
  ];
  return { columns };
};
